import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import {useEffect, useState} from 'react'
import React from 'react'
import * as bancas from '../redux/reducers'
import * as filter from '../../../redux-commons/FilterRedux/filterRedux'
import {useDispatch} from 'react-redux'
import {CustomInputBancas} from './InputBanCas'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import WcIcon from '@mui/icons-material/Wc'
import DonutSmallIcon from '@mui/icons-material/DonutSmall'
import AnalyticsIcon from '@mui/icons-material/Analytics'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import GroupsIcon from '@mui/icons-material/Groups'
import ArticleIcon from '@mui/icons-material/Article'
import InventoryIcon from '@mui/icons-material/Inventory'
import BikeScooterIcon from '@mui/icons-material/BikeScooter'
import SignalCellularNoSimIcon from '@mui/icons-material/SignalCellularNoSim'
import UpdateIcon from '@mui/icons-material/Update'
import OtherHousesIcon from '@mui/icons-material/OtherHouses'
import WarehouseIcon from '@mui/icons-material/Warehouse'
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork'
import BathroomIcon from '@mui/icons-material/Bathroom'
import PriceChangeIcon from '@mui/icons-material/PriceChange'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'

type Props = {
  id: string
  multiple?: boolean
  options: any[]
  labelId: string
  defaultValue: string
  objectSelected?: number
  handleChangeValue?: (value: string) => void
  tabName?: string
  formName?: string
  required?: boolean
  validateField?: boolean
  selectReadOnly?: boolean
}

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      marginTop: '10px',
    },
  },
}

export const SelectFieldBanCas: React.FC<Props> = ({
  id,
  multiple,
  options,
  labelId,
  defaultValue,
  handleChangeValue,
  tabName,
  formName,
  required,
  validateField,
  selectReadOnly,
  objectSelected,
}) => {
  const [selectValue, setSelectValue] = useState('')
  const dispatch = useDispatch()

  const handleSaveDataRedux = (value: string) => {
    if (formName && !formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
        tab: tabName ? tabName : '',
        form: formName,
        objectSelected: objectSelected ? objectSelected : 0,
      }
      dispatch(bancas.actions.addBancasInfors(data))
    } else if (formName && formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        field: id ? id : '',
        value: value,
        filterForm: formName,
      }
      dispatch(filter.actions.updateFilterInfo(data))
    }
  }

  const handleChange = (event: SelectChangeEvent) => {
    setSelectValue(event.target.value as string)
    handleSaveDataRedux(event.target.value)
    if (handleChangeValue) handleChangeValue(event.target.value)
  }

  const IconInput = () => (
    <>
      {id == 'businessProgramCode' && <DonutSmallIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'packageCode' && <AnalyticsIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'gender' && <WcIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'relationship' && <PeopleAltIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'customerType' && <GroupsIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'certType' && <ArticleIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'purposeOfUseType' && <InventoryIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'vehicleGroupsCode' && <BikeScooterIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'hasLicense' && <SignalCellularNoSimIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'timeDuration' && <UpdateIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'houseType' && <MapsHomeWorkIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'ownerType' && <WarehouseIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'businessHouseType' && <OtherHousesIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'fireFighting' && <BathroomIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'benefits' && <PriceChangeIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'loanTime' && <UpdateIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'bank' && <AccountBalanceIcon color='disabled' style={{opacity: '0.7'}} />}
    </>
  )

  useEffect(() => {
    if (defaultValue) setSelectValue(defaultValue)
    else setSelectValue('')
  }, [defaultValue])

  return (
    <div className='field-wrapper'>
      <FormControl error={validateField} sx={{width: '100%'}}>
        <InputLabel id={labelId} htmlFor={id}>
          {labelId} {required && <span>*</span>}
        </InputLabel>
        <Select
          labelId={labelId}
          id={id}
          multiple={multiple}
          value={selectValue}
          startAdornment={
            <InputAdornment position='start'>
              <IconInput />
            </InputAdornment>
          }
          onChange={handleChange}
          readOnly={selectReadOnly}
          input={<CustomInputBancas label={labelId} disabled={selectReadOnly} />}
          MenuProps={MenuProps}
          disabled={selectReadOnly}
        >
          {options.map((o, i) => (
            <MenuItem key={i} value={o.value} disabled={o.disable}>
              {/* <AddTaskIcon /> */}
              {/* <ListItemText primary={o.label} /> */}
              {o.image && (
                <img
                  alt='Logo'
                  className='h-30px'
                  style={{marginRight: '15px'}}
                  src={toAbsoluteUrl(o.image)}
                />
              )}
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}
